export const CREATE_BOARD = 'events/CREATE_BOARD';

/**
 * @param board
 * @return {{type: string, payload: {intl, messages}}
 */
export const createBoard = (intl, messages) => ({
  type: CREATE_BOARD,
  payload: { intl, messages },
});
